import { render } from "./dataTable.vue?vue&type=template&id=64a878af&scoped=true"
import script from "./dataTable.vue?vue&type=script&lang=js"
export * from "./dataTable.vue?vue&type=script&lang=js"

import "./dataTable.vue?vue&type=style&index=0&id=64a878af&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2159319652/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a878af"]])

export default __exports__